module.exports = __webpack_public_path__ + "static/media/Badge_PngMarquePrivilege_ScienceMd.4a10e453.png";